var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "text-sm text-gray-600 truncate mb-2",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    class: 'slider appearance-none focus:outline-none focus:outline-indigo h-0 rounded border border-pink-600 w-full',
    attrs: {
      "name": _vm.name,
      "min": 0,
      "max": _vm.rangeValues.length - 1,
      "type": "range",
      "necessary": _vm.progressCount,
      "disabled": _vm.disabled || _vm.disabled_pass
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "__r": function ($event) {
        _vm.mutableValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.sizeLibelle + ' ' + _vm.colorLibelle + ' ' + _vm.weightLibelle + ' mt-1.5 cursor-default'
  }, [_vm._v("\n      " + _vm._s(_vm.rangeValues[_vm.mutableValue]) + "\n    ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }